jQuery(window).load(function() {
		var container = document.querySelector('#ms-container');
		var msnry = new Masonry( container, {
		itemSelector: '.ms-item',
		columnWidth: '.ms-item',                
		});  
	});

function closeVideoPopup() {
  const popup = document.getElementById("videoPopup");
  const video = popup.querySelector("video"); // popup ke andar wala video

  // 1. Popup close
  popup.style.display = "none";

  // 2. Video pause + current time reset (optional)
  if (video) {
    video.pause();
    video.currentTime = 0; // agar client chahte hain fresh start
  }
}

document.addEventListener("keydown", function (e) {
  if (e.key === "Escape") {
    closeVideoPopup();
  }
});


document.addEventListener("DOMContentLoaded", function () {
  const headerGroup = document.getElementById("header-group");
  const headerTop = document.querySelector(".header-top");

  if (!headerGroup) return;

  window.addEventListener("scroll", function () {
    if (window.scrollY > 5) {
      headerGroup.classList.add("sticky");
      if (headerTop) headerTop.style.display = "none";
    } else {
      headerGroup.classList.remove("sticky");
      if (headerTop) headerTop.style.display = "";
    }
  });
});